// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__Oeyju","footer":"ModalError_footer__eqPY-"};